import { get, post, del, put } from '@api/request';

export async function fetchAllYears({ appraisalService }, authenticationToken) {
  const url = `${appraisalService}/appraisal/allyears`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchPricingSchedules(
  { appraisalService },
  authenticationToken,
  { year, type },
) {
  const url = `${appraisalService}/appraisal/pricingschedules?year=${year}&pricingType=${type}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchPricingSchedule(
  { appraisalService },
  authenticationToken,
  { pricingScheduleId },
) {
  const url = `${appraisalService}/appraisal/pricingschedule/${pricingScheduleId}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function deletePricingSchedule(
  { appraisalService },
  authenticationToken,
  { pricingScheduleId },
) {
  const url = `${appraisalService}/appraisal/pricingschedule/${pricingScheduleId}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function duplicatePricingSchedule(
  { appraisalService },
  authenticationToken,
  { pricingScheduleId },
) {
  const url = `${appraisalService}/appraisal/pricingschedule/${pricingScheduleId}/duplicate`;
  const { body } = await post(authenticationToken, url);
  return body;
}

export async function insertPricingSchedule(
  { appraisalService },
  authenticationToken,
  { data },
) {
  const url = `${appraisalService}/appraisal/pricingschedules`;
  const { body } = await post(authenticationToken, url, data);
  return body;
}

export async function updatePricingSchedule(
  { appraisalService },
  authenticationToken,
  { pricingScheduleId, data },
) {
  const url = `${appraisalService}/appraisal/pricingschedule/${pricingScheduleId}`;
  const { body } = await put(authenticationToken, url, data);
  return body;
}

export async function fetchPricingSchedulesConfig(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/pricingschedules/config`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchPricingSchedulesAxisValues(
  { appraisalService },
  authenticationToken,
  { pricingType },
) {
  const url = `${appraisalService}/appraisal/pricingschedules/config/${pricingType}/axisvalues`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchAllPricingScheduleDetails(
  { appraisalService },
  authenticationToken,
  { pricingScheduleId },
) {
  const url = `${appraisalService}/appraisal/pricingschedule/${pricingScheduleId}/details`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function initializePricingSchedule(
  { appraisalService },
  authenticationToken,
  { pricingScheduleId },
) {
  const url = `${appraisalService}/appraisal/pricingschedule/${pricingScheduleId}/initialize`;
  const { body } = await post(authenticationToken, url);
  return body;
}

export async function updatePricingScheduleDetail(
  { appraisalService },
  authenticationToken,
  { pricingScheduleDetailId, data },
) {
  const url = `${appraisalService}/appraisal/pricingscheduledetail/${pricingScheduleDetailId}`;
  const { body } = await put(authenticationToken, url, data);
  return body;
}

export async function importPricingScheduleAxisValues(
  { appraisalService },
  authenticationToken,
  { pricingScheduleId, axisType },
) {
  const url = `${appraisalService}/appraisal/pricingschedule/${pricingScheduleId}/importaxisvalues/${axisType}`;
  const { body } = await post(authenticationToken, url);
  return body;
}

export async function fetchPricingScheduleAxisValues(
  { appraisalService },
  authenticationToken,
  { pricingScheduleId },
) {
  const url = `${appraisalService}/appraisal/pricingschedule/${pricingScheduleId}/axisvalues`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function insertPricingScheduleAxisValue(
  { appraisalService },
  authenticationToken,
  { pricingScheduleId, data },
) {
  const url = `${appraisalService}/appraisal/pricingschedule/${pricingScheduleId}/axisvalues`;
  const { body } = await post(authenticationToken, url, data);
  return body;
}

export async function deletePricingScheduleAxisValue(
  { appraisalService },
  authenticationToken,
  { pricingAxisValueId },
) {
  const url = `${appraisalService}/appraisal/pricingscheduleaxisvalue/${pricingAxisValueId}`;
  const { body } = await del(authenticationToken, url);
  return body;
}
